var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSellEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M9.35,21.3a11,11,0,1,0,11-11,11,11,0,0,0-11,11",
    transform: "translate(-9.35 -10.305)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sell-eur",
    transform: "translate(-2059 -1708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2329",
    "data-name": "Rectangle 2329",
    width: 32,
    height: 32,
    transform: "translate(2059 1708)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4333",
    "data-name": "Group 4333",
    transform: "translate(2051.148 1699.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    transform: "translate(8.852 9.808)",
    fill: "#fff",
    stroke: "#1d3960",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(8.852 9.808)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 26.184,
    height: 26.375,
    transform: "translate(-2.042 -2.251)",
    fill: "#00237c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M54.791,15.753l.337,1.038H56.22l-.883.642.337,1.038-.883-.642-.883.642.337-1.038-.883-.642h1.092Z",
    transform: "translate(-43.749 -14.563)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M54.791,92.557l.337,1.038H56.22l-.883.641.337,1.038-.883-.642-.883.642.337-1.038-.883-.641h1.092Z",
    transform: "translate(-43.749 -74.592)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M93.262,54.283l.337,1.038h1.092l-.883.642L94.146,57l-.883-.642L92.379,57l.337-1.038-.883-.642h1.092Z",
    transform: "translate(-73.817 -44.677)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M16.389,54.154l.337,1.038h1.092l-.883.641.337,1.038-.883-.642-.883.642.337-1.038-.883-.641h1.092Z",
    transform: "translate(-13.735 -44.577)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M21.509,34.7l.337,1.038h1.092l-.883.642.337,1.038-.883-.642-.883.642.337-1.038-.883-.642h1.092Z",
    transform: "translate(-17.736 -29.37)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M35.205,20.617l.337,1.038h1.092l-.883.641.337,1.038-.883-.642-.883.642L34.66,22.3l-.883-.641h1.092Z",
    transform: "translate(-28.441 -18.365)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M87.433,34.7l.337,1.038h1.092l-.883.642.337,1.038-.883-.642-.883.642.337-1.038L86,35.736H87.1Z",
    transform: "translate(-69.261 -29.37)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M73.607,20.617l.337,1.038h1.092l-.883.641.337,1.038-.883-.642-.883.642.337-1.038-.883-.641H73.27Z",
    transform: "translate(-58.455 -18.365)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M21.509,73.1l.337,1.038h1.092l-.883.642.337,1.038-.883-.641-.883.641.337-1.038-.883-.642h1.092Z",
    transform: "translate(-17.736 -59.384)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M35.205,86.8l.337,1.038h1.092l-.883.642.337,1.038-.883-.642-.883.642.337-1.038-.883-.642h1.092Z",
    transform: "translate(-28.441 -70.089)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M87.433,73.1l.337,1.038h1.092l-.883.642.337,1.038-.883-.641-.883.641.337-1.038L86,74.138H87.1Z",
    transform: "translate(-69.261 -59.384)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M73.607,86.8l.337,1.038h1.092l-.883.642.337,1.038-.883-.642-.883.642.337-1.038-.883-.642H73.27Z",
    transform: "translate(-58.455 -70.089)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4334",
    "data-name": "Group 4334",
    transform: "translate(2237.281 1726.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    transform: "translate(-171.281 -11.429)",
    fill: "#fff",
    stroke: "#1d3960",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "united-states",
    transform: "translate(-171.28 -11.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(0.414 2.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M244.87,192.355h12.553a12.044,12.044,0,0,0-.414-3.138H244.87Z",
    transform: "translate(-233.839 -182.962)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M244.87,58.79h10.787a12.094,12.094,0,0,0-2.776-3.138H244.87Z",
    transform: "translate(-233.839 -55.652)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M104.1,458.963a11.9,11.9,0,0,0,7.458-2.615H96.644A11.9,11.9,0,0,0,104.1,458.963Z",
    transform: "translate(-92.517 -437.58)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M10.167,325.92H30.641a11.974,11.974,0,0,0,1.348-3.138H8.819A11.974,11.974,0,0,0,10.167,325.92Z",
    transform: "translate(-8.819 -310.271)",
    fill: "#d80000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M5.573,1.879h1.1l-1.02.741.39,1.2-1.02-.741L4,3.818l.336-1.036A12.1,12.1,0,0,0,2,5.383h.351L1.7,5.855q-.152.253-.291.514l.31.954L1.145,6.9q-.216.457-.393.934l.341,1.051h1.26l-1.02.741.39,1.2L.7,10.086l-.611.444A12.146,12.146,0,0,0,0,12.03H12.03V0A11.973,11.973,0,0,0,5.573,1.879Zm.466,8.948-1.02-.741L4,10.827l.39-1.2-1.02-.741h1.26l.389-1.2.389,1.2h1.26l-1.02.741Zm-.39-4.7.39,1.2-1.02-.741L4,7.323l.39-1.2-1.02-.741h1.26l.389-1.2.389,1.2h1.26Zm4.7,4.7-1.02-.741-1.02.741.39-1.2-1.02-.741h1.26l.389-1.2.389,1.2h1.26l-1.02.741Zm-.39-4.7.39,1.2-1.02-.741-1.02.741.39-1.2-1.02-.741h1.26l.389-1.2.389,1.2h1.26Zm0-3.5.39,1.2-1.02-.741-1.02.741.39-1.2-1.02-.741h1.26L9.334.68l.389,1.2h1.26Z",
    fill: "#0052b4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellEur);
export default __webpack_public_path__ + "static/media/icon_sell-eur.06a85b9475f31756466df908aaa61f97.svg";
export { ForwardRef as ReactComponent };